import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import { requestBodyScrollLock } from "../../utils/bodyScrollLock";

/**
 * Centered overlay; backdrop click calls onClose unless preventClose is set.
 * Content area stops propagation so inner clicks do not close.
 */
const Modal = ({ open = true, onClose, children, dialogClassName = "w-full max-w-lg", preventClose = false }) => {
  useEffect(() => {
    if (!open) return;
    const releaseScroll = requestBodyScrollLock();
    const onKey = (e) => {
      if (preventClose) return;
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      releaseScroll();
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose, preventClose]);

  if (!open) {
    return null;
  }

  const modal = (
    <div
      className="fixed inset-0 z-[90] flex min-h-[100vh] min-h-[100dvh] w-full items-center justify-center p-4 bg-black/60"
      onClick={preventClose ? undefined : onClose}
      role="presentation"
    >
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" className={dialogClassName}>
        {children}
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return null;
  }
  return createPortal(modal, document.body);
};

export default Modal;
